<div class="ordenador" *ngIf="columnas?.length">

  <div class="ordenador-campo">
    <label class="ordenador-label mb-1">{{t.ordenarpor}}</label>
    <select class="form-control form-control-sm"
            [(ngModel)]="campo"
            [ngModelOptions]="{standalone: true}">
      <option [ngValue]="undefined" disabled>{{t.seleccionecolumna}}</option>
      <option *ngFor="let columna of columnas" [ngValue]="columna.campo">{{columna.etiqueta}}</option>
    </select>
  </div>

  <div class="ordenador-campo ordenador-campo-direccion">
    <label class="ordenador-label mb-1">{{t.direccionorden}}</label>
    <select class="form-control form-control-sm"
            [(ngModel)]="direccion"
            [ngModelOptions]="{standalone: true}">
      <option value="asc">{{t.ascendente}}</option>
      <option value="desc">{{t.descendente}}</option>
    </select>
  </div>

  <button type="button"
          class="btn btn-primary btn-sm ordenador-accion"
          [disabled]="!campo"
          (click)="onOrdenar()">{{t.ordenar}}</button>

</div>
